module.exports = "uniform vec3 uColor;\nuniform sampler2D uTexture;\nuniform sampler2D uMask;\n\nvarying vec2 vUv;\n\nvoid main()\n{\n    vec4 textureColor = texture2D(uTexture, vUv);\n    vec4 maskColor = texture2D(uMask, vUv);\n    vec3 color = pow(uColor, vec3(2.0));\n    gl_FragColor = vec4(color, textureColor.r * maskColor.r);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/app-experience/Experience/shaders/topography.fragment.glsl
// module id = OPaq
// module chunks = 1